import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Collapse,
  NavbarToggler,
  Container,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {Link} from "react-router-dom";
import {useAuthUrl} from "../utils/authRedirect";
import {useState} from "react";
import { useSelector } from "react-redux";
import { FaSun, FaMoon } from "react-icons/fa";
import logo from "../assets/logos/deja.png";
import { useTheme } from "../context/ThemeContext";

const Header = () => {
  const authUrlFor = useAuthUrl();
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [accountDropdownOpen, setAccountDropdownOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const { theme, toggleTheme } = useTheme();

  const loggedIn = useSelector(
    (state: RootReducerState) => state.authentication.loggedIn
  );

  return (
    <Navbar expand="md" className="navbar-custom">
      <Container className="d-flex justify-content-between align-items-center">
        <NavbarBrand href="/" className="brand">
          <div className="logo-container">
            <img src={logo} className="logo" />
          </div>
        </NavbarBrand>

        <NavbarToggler onClick={toggle} />

        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto nav-links" navbar>
            <NavItem>
              <NavLink tag={Link} to="/featured">
                TODAY&apos;S MATCHES
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to="/dashboard">
                LOOKUP TICKER
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to="/ticker">
                ALL TIMEFRAMES
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to="/patterns">
                PATTERNS
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to="/top-stocks">
                MOMENTUM RANKS
              </NavLink>
            </NavItem>

            {loggedIn && (
              <NavItem>
                <NavLink tag={Link} to="/feed">
                  FEED
                </NavLink>
              </NavItem>
            )}

            <Dropdown
              nav
              inNavbar
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
              isOpen={dropdownOpen}
              toggle={() => setDropdownOpen((v) => !v)}
            >
              <DropdownToggle nav>
                MORE
              </DropdownToggle>
              <DropdownMenu right className="dropdown-menu-header">
                <DropdownItem href="/about">About</DropdownItem>
                <DropdownItem href="/earnings">Earnings Calendar</DropdownItem>
                <DropdownItem href="/game">Call the Chart</DropdownItem>
                <DropdownItem href="/draw">Draw a Chart</DropdownItem>
                <DropdownItem href="/trends">Featured Trends</DropdownItem>
                <DropdownItem href="/screener">Signal Screener</DropdownItem>
                <DropdownItem href="/pricing">Pricing</DropdownItem>
                <DropdownItem href="/developers">API</DropdownItem>
                <DropdownItem href="/blog">Blog</DropdownItem>
              </DropdownMenu>
            </Dropdown>

            <NavItem className="ms-md-2 mt-2 mt-md-0 d-flex align-items-center">
              <Button
                color="link"
                className="theme-toggle-btn"
                onClick={toggleTheme}
                aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
              >
                {theme === 'light' ? <FaMoon size={18} /> : <FaSun size={18} />}
              </Button>
            </NavItem>

            {loggedIn ? (
              <Dropdown
                nav
                inNavbar
                onMouseEnter={() => setAccountDropdownOpen(true)}
                onMouseLeave={() => setAccountDropdownOpen(false)}
                isOpen={accountDropdownOpen}
                toggle={() => setAccountDropdownOpen((v) => !v)}
              >
                <DropdownToggle nav>
                  ACCOUNT
                </DropdownToggle>
                <DropdownMenu right className="dropdown-menu-header">
                  <DropdownItem href="/account">My Account</DropdownItem>
                  <DropdownItem href="/logout">Log out</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            ) : (
              <NavItem className="ms-md-2 mt-3 mt-md-0">
                <Link to={authUrlFor("/login")}>
                  <Button color="primary" outline className="login-btn-outline">
                    LOG IN
                  </Button>
                </Link>
              </NavItem>
            )}

            {!loggedIn && (
              <NavItem className="ms-md-2 mt-2 mt-md-0">
                <Link to={authUrlFor("/signup")}>
                  <Button color="primary" className="signup-btn">
                    SIGN UP
                  </Button>
                </Link>
              </NavItem>
            )}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
